import React, { useRef } from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import Download from '@catalogo/ui-americanas-desktop-svg/download.svg';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box';
import {
  containsValue,
  createRow,
} from '@catalogo/ui-americanas-mobile-product-main-area/src/components/spec-drawer/index';

export const ProductSpecs = ({ product }) => {
  const ref = useRef(null);

  const renderAtributes = () => {
    const { id } = product || {};
    const attributes = getIn(product, ['attributes'], []);
    const eans = getIn(product, ['skus', 0, 'eans', 0]) || null;
    const customAttibutes = [
      { name: 'Código', value: id },
      { name: 'Código de barras', value: eans },
    ];
    return (
      <SpecsCell>
        <tbody>
          {customAttibutes?.filter(containsValue).map(createRow)}
          {attributes?.map(createRow)}
        </tbody>
      </SpecsCell>
    );
  };

  return (
    <AccordionBox ref={ref} title="Ficha Técnica" htmlElTitle="h2" visibilityOnInit={false} metricId="ficha técnica">
      <TextWrapper>{renderManual()}</TextWrapper>
      <DeskWrapper>{renderAtributes()}</DeskWrapper>
    </AccordionBox>
  );
};

export const renderManual = product => {
  const manual = product?.manuals?.[0];
  const isValidManual = manual?.includes('.pdf');

  if (isValidManual) {
    return (
      <LinkWrapper>
        <Link href={manual} target="_blank">
          baixar manual de instruções
          <DownloadIcon width={15} height={15} fill="#666" aria-hidden="true" />
        </Link>
      </LinkWrapper>
    );
  }
};

const DownloadIcon = styled(Download)`
  margin-left: 7px;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const LinkWrapper = styled.div`
  padding: 30px 0 10px 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DeskWrapper = styled.div`
  background-color: #fff;
`;

const SpecsCell = styled.table`
  width: 100%;
`;

export default ProductSpecs;
